module.exports = __webpack_public_path__ + "img/top_center.f9591b9f.svg";